/** @file Link button that navigates to a specific tenant's login page. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as icons from '@codegrade/icons';
import { Icon } from '@/components/Icon';
import { routeTenantLogin } from './routes';
/** Button link to a previously used or suggested tenant's login page. */
export const GotoTenantLink = tsx.component({
    name: 'goto-tenant-link',
    props: {
        tenant: p.ofType().required,
    },
    /** @returns The rendered tenant link JSX. */
    render() {
        return (<router-link class={[
                'cg-btn btn-actionable-4 justify-between',
                'pl-3 pr-2 py-4',
                'hover:no-underline',
                'label-large',
            ]} to={routeTenantLogin(this.$router, this.tenant.id)}>
                {this.tenant.name}
                <Icon icon={icons.ArrowRight}/>
            </router-link>);
    },
});
